import { render, staticRenderFns } from "./LeverageDialog.vue?vue&type=template&id=37cd4a3c&scoped=true&lang=pug&"
import script from "./LeverageDialog.vue?vue&type=script&lang=js&"
export * from "./LeverageDialog.vue?vue&type=script&lang=js&"
import style0 from "./LeverageDialog.vue?vue&type=style&index=0&id=37cd4a3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cd4a3c",
  null
  
)

export default component.exports